export { default as OtherDocsScreen } from './Others';
